var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-row list-view position-relative" },
    [
      _vm.vehicle.warrantyEligible
        ? _c(
            "div",
            { staticClass: "warranty-ribbon" },
            [_c("warranty-ribbon")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-link",
        {
          staticClass:
            "listing-image-container align-items-center d-flex flex-column",
          on: { click: _vm.hotSpotHandler }
        },
        [
          _c("fixed-vehicle-image", {
            staticClass: "listing-image",
            attrs: {
              "image-url": _vm.vehicle.imageUrl,
              "backup-image-url": _vm.vehicle.genericImageUrl,
              "body-style": _vm.vehicle.bodyStyle
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-container d-flex flex-column justify-content-between w-100 py-3 pr-4"
        },
        [
          _c("div", { staticClass: "content d-flex flex-column" }, [
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("div", { staticClass: "left-section d-flex flex-column" }, [
                _c("div", { staticClass: "year-make" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.yearsDisplay) +
                      " " +
                      _vm._s(_vm.vehicle.make) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "model" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.vehicle.model) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "msrp-starting font-italic" }, [
                  _vm._v(
                    "\n                        MSRP starting at\n                        " +
                      _vm._s(
                        _vm._f("numeral")(_vm.vehicle.lowestMsrp, "$0,0")
                      ) +
                      "\n                    "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "right-section d-flex text-right justify-content-between"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "save-up-to d-flex flex-column pr-3",
                      class: { invisible: !_vm.hasBiggestSavings }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text font-italic" },
                        [
                          _vm._v(
                            "\n                            save up to\n                            "
                          ),
                          _vm.vehicle.biggestSavings
                            ? _c("tooltip-disclaimer", {
                                attrs: {
                                  title: _vm.vehicle.biggestSavings.disclaimer
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("numeral")(
                                _vm.vehicle.biggestSavings.value,
                                "$0,0"
                              )
                            ) +
                            "\n                        "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.hasLowestPayment
                    ? _c("div", { staticClass: "flex-column" }, [
                        _c(
                          "div",
                          { staticClass: "as-low-as" },
                          [
                            _c("span", { staticClass: "font-italic" }, [
                              _vm._v(
                                "\n                                as low as \n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "value" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm._f("numeral")(
                                      _vm.vehicle.lowestPrice.value,
                                      "$0,0"
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.vehicle.lowestPrice
                              ? _c("tooltip-disclaimer", {
                                  attrs: {
                                    title: _vm.vehicle.lowestPrice.disclaimer
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "monthly-price-container" }, [
                          _c("div", { staticClass: "monthly-price-value" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm._f("numeral")(
                                    _vm.vehicle.lowestPayment.value,
                                    "$0,0"
                                  )
                                ) +
                                "\n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "monthly-price-footer font-italic text-lowercase"
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.vehicle.lowestPayment.type) +
                                  " /mo.\n                                "
                              ),
                              _vm.vehicle.lowestPayment
                                ? _c("tooltip-disclaimer", {
                                    attrs: {
                                      title:
                                        _vm.vehicle.lowestPayment.disclaimer
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ])
                    : !_vm.hasLowestPayment
                    ? _c("div", { staticClass: "flex-column" }, [
                        _c(
                          "div",
                          { staticClass: "starting-price" },
                          [
                            _c("span", { staticClass: "font-italic" }, [
                              _vm._v(
                                "\n                                starting at\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.vehicle.lowestPrice
                              ? _c("tooltip-disclaimer", {
                                  attrs: {
                                    title: _vm.vehicle.lowestPrice.disclaimer
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "starting-price-lg" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("numeral")(
                                  _vm.vehicle.lowestPrice.value,
                                  "$0,0"
                                )
                              ) +
                              "\n                        "
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer-container d-flex justify-content-between" },
            [
              _c("div", { staticClass: "certified-flag" }, [
                _vm.vehicle.certified
                  ? _c("span", { staticClass: "orange-bold" }, [
                      _vm._v("CarSaver Certified Dealer")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.vehicle.supplierPricingAvailable
                  ? _c("span", [_vm._v("Supplier Pricing Available")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cta-container d-flex" }, [
                _vm.isListingsAvailable
                  ? _c("div", { staticClass: "cta split" }, [
                      _c(
                        "a",
                        {
                          staticClass: "view-listing",
                          attrs: { href: _vm.listingsUrl }
                        },
                        [
                          _vm._v(
                            "\n                        View Listings\n                        "
                          ),
                          _vm.vehicle.count
                            ? _c(
                                "b-badge",
                                { attrs: { pill: "", variant: "danger" } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("numeral")(
                                          _vm.vehicle.count,
                                          "0,0"
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "cta" }, [
                  _c(
                    "a",
                    {
                      staticClass: "cta build-price",
                      attrs: { href: _vm.buildAndPriceUrl }
                    },
                    [
                      _vm._v(
                        "\n                        Build & Price\n                    "
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }